import { isObject, isString } from 'angular';

import { Option } from '@contact/upgrade';

export class Domain {
  public root: boolean;

  private parentList: string[];
  private children: Domain[];
  public metrics: any;
  public aggregatedMetrics: any;

  constructor(
    public id: string,
    public uuid: string,
    public name: string,
    public fullName: string,
    public parentId: string,
    public parentUuid: string,
    public parentName: string,
    public open: boolean
  ) {
    this.root = false;
    this.parentList = [];
    this.children = [];
    this.metrics = {};
    this.aggregatedMetrics = {};
  }

  public static of(domainData: any, metricNames): Domain {
    let data: any = Option.of(domainData)
      .filter(d => isObject(d))
      .getOrElseFunc(() => ({
        open: true,
        domainUuid: 'defaultId',
        domainParent: 'defaultParent',
        domainFullName: '#',
        domainName: 'default',
      }));

    let domain: Domain = new Domain(
      data.domainUuid,
      data.domainUuid,
      data.domainName,
      data.domainFullName,
      data.domainParent,
      data.domainParent,
      data.domainParentName,
      data.open
    );

    metricNames.forEach(metricName => {
      domain.metrics[metricName] = 0;
      domain.aggregatedMetrics[metricName] = 0;
    });

    return domain;
  }

  addChild(childDomain: Domain) {
    if (isObject(childDomain)) {
      this.children.push(childDomain);
    }
  }

  getChildren(): Domain[] {
    return this.children;
  }

  addParentId(parentId: string) {
    if (isString(parentId)) {
      this.parentList.push(parentId);
    }
  }

  getParentIds(): string[] {
    return this.parentList;
  }

  getSeed(): number {
    return this.parentList.length;
  }
}
